<template>
  <div>
    <confirmation-prompt
      id="selectCustomerAgainPrompt"
      :title="'Toevoegen als inruilauto'"
      :show="show"
      :info-text="'Wil je deze auto ook toevoegen als inruilauto?'"
      @confirm="confirmAddExchangeCar"
      @close="close"
    >
      <div v-if="vehicleInformationExtended.ModelName" class="car-details">
        <car-details :details="vehicleInformationExtended" :read-only="true" />
      </div>
    </confirmation-prompt>
  </div>
</template>

<script>
import ConfirmationPrompt from '@/components/generic/presentational/molecules/confirmationPrompt/ConfirmationPrompt.vue'
import CarDetails from '@/components/generic/presentational/molecules/carDetails/CarDetails.vue'
import { mapGetters, mapActions } from 'vuex'
import { EventBus } from '@/plugins/event-bus'

export default {
  components: {
    ConfirmationPrompt,
    CarDetails,
  },
  data() {
    return {
      vehicleInformationExtended: {},
      show: false,
    }
  },
  computed: {
    ...mapGetters({
      customerInfo: 'quote/customer',
      exchangeCars: 'quote/exchangeCars',
    }),
    hasExchangeCars() {
      return this.exchangeCars?.filter((car) => car.ModelName != null).length > 0
    },
  },
  created() {
    EventBus.$on('proposeExchangeCar', this.setProposedExchangeCar)
  },
  unmounted() {
    EventBus.$off('proposeExchangeCar', this.setProposedExchangeCar)
  },
  methods: {
    ...mapActions({
      addExchangeCar: 'quote/addExchangeCar',
      saveQuote: 'quote/createOrUpdate',
    }),
    async setProposedExchangeCar(vehicle) {
      this.vehicleInformationExtended = vehicle
      this.show = !this.hasExchangeCars && !!this.vehicleInformationExtended
    },
    close() {
      this.show = false
    },
    confirmAddExchangeCar() {
      this.addExchangeCar(this.vehicleInformationExtended)
      this.saveQuote()
      this.close()
    },
  },
}
</script>
